import { SearchFieldInfo } from './search-field-info';

export class AddSearchSessionActivityRequest {
    constructor(
        public readonly category: string,
        public readonly fields: SearchFieldInfo[]
    ) { }
}